import {useSelector} from 'react-redux';

export function useLocale() {
  return useSelector((state) => state.i18nReducer.language);
}
